export const teams = [
  {
    id: 1,
    logo: 'https://web-resource.17m3.com/m3guo/202312/vote-ic1a/guessItem/sfy.png',
    name: '三分月'
  },
  {
    id: 2,
    logo: 'https://web-resource.17m3.com/m3guo/202312/vote-ic1a/guessItem/sy.png',
    name: '诗月'
  },
  {
    id: 3,
    logo: 'https://web-resource.17m3.com/m3guo/202312/vote-ic1a/guessItem/sg.png',
    name: '曙光'
  },
  {
    id: 4,
    logo: 'https://web-resource.17m3.com/m3guo/202312/vote-ic1a/guessItem/l21.png',
    name: '灵21'
  }
];

export const team_data = [
  { id: 1, name: '三分月', player_list: [
      { pid: '11', name: '山鬼谣', link: 'https://www.m3guo.com/activity/202205/mpl/info/?mid=247&tid=1' },
      { pid: '21', name: '小虎', link: 'https://www.m3guo.com/activity/202205/mpl/info/?mid=248&tid=1' },
      { pid: '31', name: '张子凡', link: 'https://www.m3guo.com/activity/202205/mpl/info/?mid=249&tid=1' },
      { pid: '41', name: '果仔', link: 'https://www.m3guo.com/activity/202205/mpl/info/?mid=250&tid=1' },
      { pid: '51', name: '烤蟹', link: 'https://www.m3guo.com/activity/202205/mpl/info/?mid=251&tid=1' }
  ] },
  { id: 2, name: '诗月', player_list: [
      { pid: '12', name: '流星', link: 'https://www.m3guo.com/activity/202205/mpl/info/?mid=280&tid=2' },
      { pid: '22', name: '冷傲', link: 'https://www.m3guo.com/activity/202205/mpl/info/?mid=281&tid=2' },
      { pid: '32', name: '昊凡', link: 'https://www.m3guo.com/activity/202205/mpl/info/?mid=282&tid=2' },
      { pid: '42', name: '相遇', link: 'https://www.m3guo.com/activity/202205/mpl/info/?mid=283&tid=2' },
      { pid: '52', name: '水中月', link: 'https://www.m3guo.com/activity/202205/mpl/info/?mid=284&tid=2' }
  ] },
  { id: 3, name: '曙光', player_list: [
      { pid: '13', name: '豪豪', link: 'https://www.m3guo.com/activity/202205/mpl/info/?mid=267&tid=9' },
      { pid: '23', name: '无敌', link: 'https://www.m3guo.com/activity/202205/mpl/info/?mid=268&tid=9' },
      { pid: '33', name: '小可', link: 'https://www.m3guo.com/activity/202205/mpl/info/?mid=270&tid=9' },
      { pid: '43', name: '酒窝凯', link: 'https://www.m3guo.com/activity/202205/mpl/info/?mid=269&tid=9' },
      { pid: '53', name: '月下孤影', link: 'https://www.m3guo.com/activity/202205/mpl/info/?mid=271&tid=9' }
  ] },
  { id: 4, name: '灵21', player_list: [
      { pid: '14', name: '清月', link: 'https://www.m3guo.com/activity/202205/mpl/info/?mid=260&tid=10' },
      { pid: '24', name: '寒潮', link: 'https://www.m3guo.com/activity/202205/mpl/info/?mid=261&tid=10' },
      { pid: '34', name: '疯狂一秒', link: 'https://www.m3guo.com/activity/202205/mpl/info/?mid=262&tid=10' },
      { pid: '44', name: '初恋', link: 'https://www.m3guo.com/activity/202205/mpl/info/?mid=264&tid=10' },
      { pid: '54', name: '夏日', link: 'https://www.m3guo.com/activity/202205/mpl/info/?mid=349&tid=10' }
  ] }
];

export default { teams, team_data };
